import { isFunction } from '@/global/utils/utils'

const TAB_KEY = 'basicInfo'
export default {
  data () {
    return {
      readonlyFields: {
        serial: false,
        imei: false,
        installation_method: false,
        comment: false
      }
    }
  },

  computed: {
    basicInfoConfig () {
      return {
        title: this.$t('base/tracker.basic_info'),
        key: TAB_KEY,
        apiConfig: {
          get: {
            module: 'base',
            route: `tracker/${this.resolveRouteParamValue('id')}/basic-info`
          },
          post: {
            module: 'base',
            route: `tracker/${this.resolveRouteParamValue('id')}/basic-info`
          }
        },
        dataFetched: (event) => this.onBasicInfoDataFetched(event),
        afterSave: (event, data) => this.onBasicInfoDataFetched({
          updateData: event?.updateData,
          data: {
            data
          }
        }),
        afterCancel: (event) => this.onBasicInfoDataFetched({
          updateData: event?.updateData,
          data: {
            data: event?.formDataForSend
          }
        }),
        tabContent: [
          {
            component: this.tabActionButtonsComponent,
            title: this.$t('base/tracker.basic_info'),
            showBackButton: {
              onGoBack: () => this.navigatesToTableView(this.trackersOverviewViewName)
            }
          },
          {
            component: this.columnsContentComponent,
            showButtons: false,
            rows: [
              {
                type: 'fields',
                columnsCount: 2,
                fields: [
                  {
                    key: 'model_id',
                    label: this.$t('base/tracker.model'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'base',
                      route: 'tracker-model/autocomplete'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'sim_id',
                    label: this.$t('base/sim.sim'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'base',
                      route: 'sim/autocomplete'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'serial',
                    label: this.$t('base/tracker.serial'),
                    props: {
                      dependantReadonly: (event) => {
                        const { editState } = event || {}
                        return editState ? this.readonlyFields.serial : false
                      }
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'imei',
                    label: this.$t('base/tracker.imei'),
                    props: {
                      dependantReadonly: (event) => {
                        const { editState } = event || {}
                        return editState ? this.readonlyFields.imei : false
                      }
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'installation_method',
                    label: this.$t('base/tracker.installation_method'),
                    props: {
                      dependantReadonly: (event) => {
                        const { editState } = event || {}
                        return editState ? this.readonlyFields.installation_method : false
                      }
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'comment',
                    label: this.$t('base/tracker.comment'),
                    props: {
                      dependantReadonly: (event) => {
                        const { editState } = event || {}
                        return editState ? this.readonlyFields.comment : false
                      }
                    },
                    type: 'textarea',
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  },

  methods: {
    onBasicInfoDataFetched (event) {
      const {
        master_app: fromMasterApp,
        sim_id: simId,
        model_id: modelId
      } = event?.data?.data || {}
      const { updateData } = event || {}
      const { permissions } = event?.data?.meta || {}
      // Only update permissions when they are present (initial data fetch).
      // afterSave/afterCancel callbacks do not include meta, so permissions
      // would be undefined — clearing them here causes tab visibility to flash.
      if (permissions !== undefined) {
        this.permissions = permissions
      }

      this.$set(this.readonlyFields, 'serial', !!fromMasterApp)
      this.$set(this.readonlyFields, 'imei', !!fromMasterApp)
      this.$set(this.readonlyFields, 'installation_method', !!fromMasterApp)
      this.$set(this.readonlyFields, 'comment', !!fromMasterApp)

      if (isFunction(updateData)) {
        updateData({
          sim_id: simId?.id || simId || null,
          model_id: modelId?.id || modelId || null
        })
      }
    }
  }
}
